import { MDText } from 'i18n-react';

import { Button, SpeechIcon } from '@motorway/mw-highway-code';

import { AgentsBox } from '../AgentsBox/AgentsBox';

import LocalTexts from './GetInTouch.texts.json';

import styles from './GetInTouch.scss';

type GetInTouchProps = {
  onClick?: () => void;
  openChat?: boolean;
};

const LocalT = new MDText(LocalTexts);

export const GetInTouch = ({ onClick, openChat = false }: GetInTouchProps) => {
  const handleClick = () => {
    if (openChat) {
      globalThis?.zE?.('messenger', 'open');
    }
    onClick?.();
  };

  const title = openChat ? 'needHelp' : 'notHappy';
  const description = openChat ? 'chatThroughout' : 'exploreOptions';

  const buttonConfig = openChat
    ? { as: 'button' as const, icon: SpeechIcon, label: LocalT.translate('speakToTeam') }
    : { as: 'a' as const, href: `tel:${LocalT.translate('phone')}`, icon: 'phone' as const, label: LocalT.translate('phone_pretty') };

  return (
    <div className={styles.getInTouch}>
      <div className={styles.header}>
        <h5 className={styles.title}>{LocalT.translate(title)}</h5>
        <AgentsBox />
      </div>
      <p data-thc-style-override className={styles.description}>{LocalT.translate(description)}</p>
      <Button fullWidth reverse {...buttonConfig} onClick={handleClick} variant='secondary' />
    </div>
  );
};
